import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { LoadingController, ModalController, ToastController } from "@ionic/angular";
import * as moment from "moment";

@Component({
  selector: "app-card-vacina-component",
  templateUrl: "./card-vacina-component.component.html",
  styleUrls: ["./card-vacina-component.component.scss"],
})
export class CardVacinaComponentComponent implements OnInit {
  @Input("data") vacina;
  @Input("ultimo") ultimo;
  @Output() acao = new EventEmitter();


  constructor(
    public loadingCtrl: LoadingController,
  ) { }

  ngOnInit() {
    console.log('=====this.vacina', this.vacina);
  }

  abrirItem() {
    this.vacina.selecionado = !this.vacina.selecionado;
  }

  dateLabel(date: string) {
    return `${moment(date).format("L")}`;
  }

  gerar(event, acao) {
    console.log('=====', acao);
    this.acao.emit(acao);
    event.stopPropagation();
  }
}
